import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import BaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default BaseFragment.extend({
  unitToken: attr('string'),
  unitNickname: attr('string'),
  addressToken: attr('string'),
  address: fragment('squareup/common/location/global-address-ed')
});